import store from '../store'
import { actionTypes as pagePropsActionTypes } from '../store/reducers/pageProps'

export default function setPageProps(props) {
  store.dispatch({ type: pagePropsActionTypes.SET, payload: props })
}
